function DesktopIntro({ onOpenFeatured, onBrowseApps }) {
  return (
    <section className="desktop-intro panel-glass">
      <p className="eyebrow">Portfolio OS</p>
      <h1>Erick The Dev</h1>
      <p className="intro-copy">
        Game developer with web experience. Open the apps below to explore
        my projects, skills, and background.
      </p>
      <div className="intro-actions">
        <button type="button" className="primary-action" onClick={onOpenFeatured}>
          Open featured work
        </button>
        <button type="button" className="secondary-action" onClick={onBrowseApps}>
          Browse apps
        </button>
      </div>
    </section>
  );
}

export default DesktopIntro;
